import { axios } from '@/utils/request'

const CONFIG_MANAGE_API = '/configuration'
const APPLICATION_API = '/application'

export function getConfigManagePage (data) {
  return axios({
    url: CONFIG_MANAGE_API + '/page?pageNumber=' + data.pageNumber + '&pageSize=' + data.pageSize,
    method: 'post',
    data: data
  })
}
export function getApplicationPage (data) {
  return axios({
    url: APPLICATION_API + '/page?pageNumber=' + data.pageNumber + '&pageSize=' + data.pageSize,
    method: 'post',
    data: data
  })
}
export function getConfigManageDropdown () {
  return axios({
    url: CONFIG_MANAGE_API + '/dropdown',
    method: 'post'
  })
}
export function getApplicationDetail (id) {
  return axios({
    url: APPLICATION_API + '?id=' + id,
    method: 'get'
  })
}
export function getConfigManageDetail (id) {
  return axios({
    url: CONFIG_MANAGE_API + '/detail?id=' + id,
    method: 'get'
  })
}
export function createConfigManage (data) {
  return axios({
    url: CONFIG_MANAGE_API + '/create',
    method: 'post',
    data: data
  })
}
export function updateConfigManage (data) {
  return axios({
    url: CONFIG_MANAGE_API + '/update',
    method: 'post',
    data: data
  })
}
export function deleteConfigManage (id) {
  return axios({
    url: CONFIG_MANAGE_API + '/delete?id=' + id,
    method: 'post'
  })
}
export function deleteApplication (id) {
  return axios({
    url: APPLICATION_API + '/delete?id=' + id,
    method: 'post'
  })
}
export function createApplication (data) {
  return axios({
    url: APPLICATION_API + '/create',
    method: 'post',
    data: data
  })
}
export function updateApplication (data) {
  return axios({
    url: APPLICATION_API + '/update',
    method: 'post',
    data: data
  })
}
/* 上传文件到OSS
 * @param {*} data 文件数据
 * @param {*} type 文件类型
 * @returns 0:apk，1:图标,2开机图片3开机动画
 */
export function uploadFile (data, type) {
  return axios({
    url: '/uploadV2?type=' + type,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export function uploadV2ApkFile (data) {
  return axios({
    url: '/uploadV2Apk',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export function getAppDropdown () {
  return axios({
    url: APPLICATION_API + '/dropdown',
    method: 'post'
  })
}
